// src/routes/dashboardRoutes.js
import AjouterUser from "./views/Settings/User/AjouterUser";
import ListUser from "./views/Settings/User/ListUser";

// Import new components
import AjouterCategory from "./views/Settings/Category/AjouterCategory";
import ListCategories from "./views/Settings/Category/ListCategories";
import AjouterProduct from "./views/Settings/Product/AjouterProduct";
import ListProducts from "./views/Settings/Product/ListProducts";
import AjouterClient from "./views/Settings/Client/AjouterClient";
import ListClients from "./views/Settings/Client/ListClients";
import AjouterSupplier from "./views/Settings/Supplier/AjouterSupplier";
import ListSuppliers from "./views/Settings/Supplier/ListSuppliers";

// Import Driver components
import AjouterDriver from "./views/Settings/Drivers/AjouterDriver";
import ListDrivers from "./views/Settings/Drivers/ListDrivers";

// Import Car components
import AjouterCar from "./views/Settings/Cars/AjouterCar";
import ListCars from "./views/Settings/Cars/ListCars";

// Import Purchase Invoice components
import ListPurchaseInvoice from "./views/Settings/Invoice/FactureList";
import AddPurchaseInvoice from "./views/Settings/Invoice/AddFacture";

// Import Sale Invoice components - NEW SEPARATED COMPONENTS
import AddDeliveryNote from "./views/Settings/SaleInvoice/AddSaleInvoice/DeliveryNote/AddDeliveryNote";
import UpdateDeliveryNote from "./views/Settings/SaleInvoice/AddSaleInvoice/DeliveryNote/UpdateDeliveryNote";
import AddSalesInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/SaleInvoice/AddSalesInvoice";
import UpdateSaleInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/SaleInvoice/UpdateSalesInvoice";
import AddShippingNoteInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/ShippingNote/AddShippingNoteInvoice";
import UpdateShippingNoteInvoice from "./views/Settings/SaleInvoice/AddSaleInvoice/ShippingNote/UpdateShippingNoteInvoice";

// Import Payment components
import AjouterPayment from "./views/Settings/Payments/AjouterPayment";
import ListPayments from "./views/Settings/Payments/ListPayments";
import SaleInvoiceDetails from "./views/Settings/SaleInvoice/DetailFacture";
import CompanySettings from "./views/CompanySettings";
import ListRefundInvoice from "./views/Settings/SaleInvoiceRefund/ListRefundInvoice";
import AddRefundInvoice from "./views/Settings/SaleInvoiceRefund/AddRefundInvoice";
import ListBrands from "./views/Settings/Brands/ListBrands";
import AjouterBrand from "./views/Settings/Brands/AjouterBrand";
import ListSaleInvoice from "./views/Settings/SaleInvoice/ListSaleInvoice";
import HeroBannerList from "./views/Settings/HeroBanner/ListHeroBanner";
import AjouterHeroBanner from "./views/Settings/HeroBanner/AjouterHeroBanner";
import DetailContact from "./views/Settings/Contact/DetailContact";
import ListContact from "./views/Settings/Contact/ListContact";
import ListOrders from "./views/Settings/Order/ListOrders";
import OrderDetails from "./views/Settings/Order/OrderDetails";

const dashboardRoutes = [
  {
    path: "/orders/list",
    name: "Commandes",
    icon: "fas fa-shopping-cart",
    component: ListOrders,
    id_role: "ADMIN",
    componentStr: "ListOrders",
  },
  {
    path: "/orders/detail/:id",
    name: "Détail Commande",
    icon: "fas fa-eye",
    component: OrderDetails,
    id_role: "ADMIN",
    componentStr: "OrderDetails",
    className: "hidden",
  },
  // ==================== Hero Banner ====================
  {
    path: "/heroBanner/list",
    name: "Hero Banner",
    icon: "fas fa-image",
    component: HeroBannerList,
    id_role: "ADMIN",
    componentStr: "HeroBannerList",
  },
  {
    path: "/heroBanner/add",
    name: "heroBanner add",
    icon: "fas fa-user-plus",
    component: AjouterHeroBanner,
    componentStr: "AjouterHeroBanner",
    id_role: "ADMIN", // ADMIN only
    className: "hidden",
  },
  {
    path: "/heroBanner/update/:id",
    name: "heroBanner update",
    icon: "fas fa-user-edit",
    component: AjouterHeroBanner,
    componentStr: "AjouterHeroBanner",
    id_role: "ADMIN",
    className: "hidden",
  },
  // ==================== USER ====================
  {
    path: "/user/add",
    name: "User add",
    icon: "fas fa-user-plus",
    component: AjouterUser,
    componentStr: "AjouterUser",
    id_role: "ADMIN", // ADMIN only
    className: "hidden",
  },
  {
    path: "/user/update/:id",
    name: "User update",
    icon: "fas fa-user-edit",
    component: AjouterUser,
    componentStr: "AjouterUser",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== BRANDS ====================
  {
    path: "/brands/list",
    name: "Marques",
    icon: "fas fa-trademark",
    component: ListBrands,
    id_role: "ADMIN",
    componentStr: "ListBrands",
  },
  {
    path: "/brands/add",
    name: "Add Brand",
    icon: "fas fa-plus-circle",
    component: AjouterBrand,
    componentStr: "AjouterBrand",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/brands/update/:id",
    name: "Update Brand",
    icon: "fas fa-edit",
    component: AjouterBrand,
    componentStr: "AjouterBrand",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== CATEGORIES ====================
  {
    path: "/categories/list",
    name: "Categories",
    icon: "fas fa-tags",
    component: ListCategories,
    id_role: "ADMIN",
    componentStr: "ListCategories",
  },
  {
    path: "/categories/add",
    name: "Add Category",
    icon: "fas fa-plus-square",
    component: AjouterCategory,
    componentStr: "AjouterCategory",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/categories/update/:id",
    name: "Update Category",
    icon: "fas fa-edit",
    component: AjouterCategory,
    componentStr: "AjouterCategory",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== PRODUCTS ====================
  {
    path: "/products/list",
    name: "Products",
    icon: "fas fa-boxes",
    component: ListProducts,
    id_role: "ADMIN",
    componentStr: "ListProducts",
  },
  {
    path: "/products/add",
    name: "Add Product",
    icon: "fas fa-cart-plus",
    component: AjouterProduct,
    componentStr: "AjouterProduct",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/products/update/:id",
    name: "Update Product",
    icon: "fas fa-edit",
    component: AjouterProduct,
    componentStr: "AjouterProduct",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== CLIENTS ====================
  {
    path: "/clients/list",
    name: "Clients",
    icon: "fas fa-user-tie",
    component: ListClients,
    id_role: "ADMIN",
    componentStr: "ListClients",
  },
  {
    path: "/clients/add",
    name: "Add Client",
    icon: "fas fa-user-plus",
    component: AjouterClient,
    componentStr: "AjouterClient",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/clients/update/:id",
    name: "Update Client",
    icon: "fas fa-user-edit",
    component: AjouterClient,
    componentStr: "AjouterClient",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== SUPPLIERS ====================
  {
    path: "/suppliers/list",
    name: "Fournisseurs",
    icon: "fas fa-truck-loading",
    component: ListSuppliers,
    id_role: "ADMIN",
    componentStr: "ListSuppliers",
  },
  {
    path: "/suppliers/add",
    name: "Add Supplier",
    icon: "fas fa-plus",
    component: AjouterSupplier,
    componentStr: "AjouterSupplier",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/suppliers/update/:id",
    name: "Update Supplier",
    icon: "fas fa-edit",
    component: AjouterSupplier,
    componentStr: "AjouterSupplier",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== DRIVERS ====================
  {
    path: "/drivers/add",
    name: "Add Driver",
    icon: "fas fa-user-plus",
    component: AjouterDriver,
    componentStr: "AjouterDriver",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/drivers/update/:id",
    name: "Update Driver",
    icon: "fas fa-user-edit",
    component: AjouterDriver,
    componentStr: "AjouterDriver",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== CARS ====================
  {
    path: "/cars/add",
    name: "Add Car",
    icon: "fas fa-plus-circle",
    component: AjouterCar,
    componentStr: "AjouterCar",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/cars/update/:id",
    name: "Update Car",
    icon: "fas fa-edit",
    component: AjouterCar,
    componentStr: "AjouterCar",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== FLEET MANAGEMENT COLLAPSE ====================
  {
    collapse: true,
    path: "/fleet",
    name: "Gestion de parc",
    state: "fleet",
    icon: "fas fa-truck",
    id_role: "ADMIN",
    views: [
      {
        path: "/drivers/list",
        name: "Chauffeurs",
        icon: "fas fa-id-card",
        component: ListDrivers,
        id_role: "ADMIN",
        componentStr: "ListDrivers",
      },
      {
        path: "/cars/list",
        name: "Véhicules",
        icon: "fas fa-car",
        component: ListCars,
        id_role: "ADMIN",
        componentStr: "ListCars",
      },
    ],
  },

  // ==================== PURCHASE INVOICES ====================
  {
    collapse: true,
    path: "/purchase-invoices/list",
    name: "Factures d'achat",
    state: "purchase",
    icon: "fas fa-file-invoice-dollar",
    id_role: "ADMIN",
    views: [
      {
        path: "/purchase-invoices/list/PURCHASE_ORDER",
        name: "Bon de commande",
        icon: "fas fa-file-invoice-dollar",
        component: ListPurchaseInvoice,
        id_role: "ADMIN",
        componentStr: "ListPurchaseInvoice",
      },
      {
        path: "/purchase-invoices/list/PURCHASE_INVOICE",
        name: "Facture achat",
        icon: "fas fa-file-invoice-dollar",
        component: ListPurchaseInvoice,
        id_role: "ADMIN",
        componentStr: "ListPurchaseInvoice",
      },
    ],
  },
  {
    path: "/purchase-invoice/add",
    name: "Add Purchase Invoice",
    icon: "fas fa-plus-circle",
    component: AddPurchaseInvoice,
    componentStr: "AddPurchaseInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/purchase-order/add",
    name: "Add Purchase Invoice",
    icon: "fas fa-plus-circle",
    component: AddPurchaseInvoice,
    componentStr: "AddPurchaseInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/purchase-invoice/add",
    name: "Add Purchase Invoice",
    icon: "fas fa-plus-circle",
    component: AddPurchaseInvoice,
    componentStr: "AddPurchaseInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/purchase-invoice/update/:id",
    name: "Update Purchase Invoice",
    icon: "fas fa-edit",
    component: AddPurchaseInvoice,
    componentStr: "AddPurchaseInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== SALE INVOICES ====================
  {
    collapse: true,
    path: "/sale-invoices/list",
    name: "Factures de Vente",
    state: "sale",
    icon: "fas fa-file-invoice-dollar",
    id_role: "ADMIN,COMMERCIAL",
    views: [
      {
        path: "/sale-invoices/list/QUOTATION",
        name: "Devis",
        icon: "fas fa-file-invoice",
        component: ListSaleInvoice,
        id_role: "ADMIN",
        componentStr: "ListSaleInvoice",
      },
      {
        path: "/sale-invoices/list/DELIVERY_NOTE",
        name: "Bon de livraison",
        icon: "fas fa-file-invoice",
        component: ListSaleInvoice,
        id_role: "ADMIN,COMMERCIAL",
        componentStr: "ListSaleInvoice",
      },
      {
        path: "/sale-invoices/list/SALE_INVOICE",
        name: "Facture vente",
        icon: "fas fa-file-invoice",
        component: ListSaleInvoice,
        id_role: "ADMIN",
        componentStr: "ListSaleInvoice",
      },
      {
        path: "/sale-invoices/list/SHIPPING_NOTE_INVOICE",
        name: "Facture bon de sortie",
        icon: "fas fa-file-invoice",
        component: ListSaleInvoice,
        id_role: "ADMIN,COMMERCIAL",
        componentStr: "ListSaleInvoice",
      },
      {
        path: "/refund-invoices/list",
        name: "Facture avoir",
        icon: "fas fa-file-invoice",
        component: ListRefundInvoice,
        id_role: "ADMIN",
        componentStr: "ListRefundInvoice",
      },
    ],
  },

  // ==================== DELIVERY NOTE ROUTES ====================
  {
    path: "/delivery-note/add",
    name: "Ajouter Bon de livraison",
    icon: "fas fa-plus-circle",
    component: AddDeliveryNote,
    componentStr: "AddDeliveryNote",
    id_role: "ADMIN,COMMERCIAL",
    className: "hidden",
  },
  {
    path: "/delivery-note/update/:id",
    name: "Modifier Bon de livraison",
    icon: "fas fa-edit",
    component: UpdateDeliveryNote,
    componentStr: "UpdateDeliveryNote",
    id_role: "ADMIN,COMMERCIAL",
    className: "hidden",
  },

  // ==================== SALE INVOICE ROUTES ====================
  {
    path: "/sale-invoice/add",
    name: "Ajouter Facture de vente",
    icon: "fas fa-plus-circle",
    component: AddSalesInvoice,
    componentStr: "AddSalesInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/sale-invoice/update/:id",
    name: "Modifier Facture de vente",
    icon: "fas fa-edit",
    component: UpdateSaleInvoice,
    componentStr: "UpdateSaleInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== SHIPPING NOTE ROUTES ====================
  {
    path: "/shipping-note/add",
    name: "Ajouter Facture bon sortie",
    icon: "fas fa-plus-circle",
    component: AddShippingNoteInvoice,
    componentStr: "AddShippingNoteInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/shipping-note/update/:id",
    name: "Modifier Facture bon sortie",
    icon: "fas fa-edit",
    component: UpdateShippingNoteInvoice,
    componentStr: "UpdateShippingNoteInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== INVOICE DETAIL ====================
  {
    path: "/sale-invoice/detail/:id",
    name: "Détail Facture",
    icon: "fas fa-eye",
    component: SaleInvoiceDetails,
    componentStr: "SaleInvoiceDetails",
    id_role: "ADMIN,COMMERCIAL",
    className: "hidden",
  },

  // ==================== REFUND INVOICE ROUTES ====================
  {
    path: "/refund-invoice/add",
    name: "Ajouter Facture avoir",
    icon: "fas fa-plus-circle",
    component: AddRefundInvoice,
    componentStr: "AddRefundInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },
  {
    path: "/refund-invoice/update/:id",
    name: "Modifier Facture avoir",
    icon: "fas fa-edit",
    component: AddRefundInvoice,
    componentStr: "AddRefundInvoice",
    id_role: "ADMIN",
    className: "hidden",
  },

  // ==================== PAYMENTS ====================
  {
    path: "/payments/list",
    name: "Paiements",
    icon: "fas fa-money-check-alt",
    component: ListPayments,
    id_role: ["ADMIN", "FINANCE"],
    componentStr: "ListPayments",
  },
  {
    path: "/payments/add",
    name: "Nouveau Paiement",
    icon: "fas fa-money-bill-wave",
    component: AjouterPayment,
    componentStr: "AjouterPayment",
    id_role: ["ADMIN", "FINANCE"],
    className: "hidden",
  },
  {
    path: "/payments/update/:id",
    name: "Modifier Paiement",
    icon: "fas fa-edit",
    component: AjouterPayment,
    componentStr: "AjouterPayment",
    id_role: ["ADMIN", "FINANCE"],
    className: "hidden",
  },

  // ==================== DASHBOARD/ANALYTICS ====================
  {
    path: "/dashboard/payments-summary",
    name: "Tableau de Bord Paiements",
    icon: "fas fa-chart-line",
    component: ListPayments,
    id_role: ["ADMIN", "FINANCE", "MANAGER"],
    componentStr: "ListPayments",
    className: "hidden",
  },

  // ==================== PAYMENT REPORTS ====================
  {
    path: "/reports/payments",
    name: "Rapports Paiements",
    icon: "fas fa-file-alt",
    component: ListPayments,
    id_role: ["ADMIN", "FINANCE", "MANAGER"],
    componentStr: "ListPayments",
    className: "hidden",
  },

  // ==================== COMPANY SETTINGS ====================
  {
    path: "/companySettings",
    name: "Company Settings",
    icon: "fas fa-building",
    component: CompanySettings,
    id_role: ["ADMIN", "FINANCE", "MANAGER"],
    componentStr: "CompanySettings",
  },
  // ==================== CONTACT MESSAGES ====================
  {
    path: "/contact/list",
    name: "Messages Contact",
    icon: "fas fa-envelope",
    component: ListContact,
    id_role: "ADMIN",
    componentStr: "ListContact",
  },
  {
    path: "/contact/detail/:id",
    name: "Détail Message",
    icon: "fas fa-envelope-open-text",
    component: DetailContact,
    id_role: "ADMIN",
    componentStr: "DetailContact",
    className: "hidden",
  },
];

export default dashboardRoutes;
